import { Transition } from "@headlessui/react";
import { Children } from "react";

// https://stackoverflow.com/questions/6780614/css-how-to-position-two-elements-on-top-of-each-other-without-specifying-a-hei
/** expects two children; displays the first or second based on whether the `right` prop is true */
const AnimatedPanel: React.FC<{
  children: React.ReactNode;
  right: boolean;
}> = ({ right, children }) => {
  const childrenArray = Children.toArray(children);
  return (
    <div className="grid grid-cols-1 w-full h-full">
      <Transition
        as="div"
        show={!right}
        style={{ gridColumn: 1, gridRow: 1 }}
        enter="transition"
        enterFrom="opacity-0 -translate-x-32 scale-95"
        enterTo="opacity-100 translate-x-0 scale-100"
        leave="transition"
        leaveFrom="opacity-100 translate-x-0 scale-100"
        leaveTo="opacity-0 -translate-x-32 scale-95"
        unmount={false}
      >
        {childrenArray[0]}
      </Transition>
      <Transition
        as="div"
        show={right}
        style={{ gridColumn: 1, gridRow: 1 }}
        enter="transition"
        enterFrom="opacity-0 translate-x-32 scale-95"
        enterTo="opacity-100 translate-x-0 scale-100"
        leave="transition"
        leaveFrom="opacity-100 translate-x-0 scale-100"
        leaveTo="opacity-0 translate-x-32 scale-95"
        unmount={false}
      >
        {childrenArray[1]}
      </Transition>
    </div>
  );
};

export default AnimatedPanel;
